
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { Location } from "vue-router";
import { LOGO_URL } from "@/lib/urlHelpers";

interface Props {
  href?: string;
  to?: Location;
  imgClass?: string;
  small?: boolean;
  mobile?: boolean;
  size?: number;
}

export default Vue.extend({
  functional: true,
  name: "SiteLogo",
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { href, to, imgClass, small, size = 40, mobile } = ctx.props;
    const classes = [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass];
    const imgLogo = h("img", {
      staticClass: "logo",
      class: [...(!href && !to ? classes : []), imgClass, { __small: small }],
      style: { height: size + "px" },
      attrs: {
        alt: "logo",
        src: mobile ? "/img/logo-fanzter-mobile.png" : LOGO_URL,
      },
    });
    if (href) return h("a", { class: classes, attrs: { href } }, [imgLogo]);
    if (to) return h("router-link", { class: classes, props: { to } }, [imgLogo]);
    return h("span", { class: classes, attrs: { href } }, [imgLogo]);
  },
});
